<template>
  <b-card
    title="مدیریت جایگاه های بنر"
  >
    <b-row>
      <b-col
          class="table-size"
      >
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-button
                  class="mb-1 mr-auto ml-1"
                variant="primary"
                :to="{ name: 'addbannerposition'}"
              >
                جدید
              </b-button>
              <b-col md="2">
                <b-form-group
                  label="عنوان"
                  label-for="Title"
                >
                  <b-form-input
                    v-model="filterOptions.Title"
                    @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="صفحه"
                  label-for="Screen"
                >
                  <v-select
                    v-model="filterOptions.Screen"
                    :options="enums('Screen')"
                    dir="rtl"
                    label="text"
                    :reduce="x => x.value"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="آگهی دهنده"
                  label-for="Advertiser"
                >
                  <v-select
                    v-model="filterOptions.Advertiser"
                    :options="enums('Advertiser')"
                    dir="rtl"
                    label="text"
                    :reduce="x => x.value"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="از تاریخ"
                    label-for="FromDate"
                >
                  <date-picker
                      v-model="filterOptions.FromDate"
                      placeholder=""
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="تا تاریخ"
                    label-for="FromDate"
                >
                  <date-picker
                      v-model="filterOptions.ToDate"
                      placeholder=""
                  />
                </b-form-group>
              </b-col>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                class="mb-1 mr-1"
                variant="warning"
                @click="update(1)"
              >فیلتر
              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
          bordered
          hover
          striped
          :items="items"
          :fields="fields"
          class="mt-1 mb-2 position-relative"
          responsive
          :busy="loading"
        >
          <template #cell(Id)="data">
            <b-link
              :to="{ name: 'updatebannerposition', params: { id: data.value }}"
              class="font-weight-bold"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(Advertiser)="data">
            <b-badge
              v-for="(item, index) in data.value"
              :key="index"
              style="line-height: unset; margin: 2px;"
              variant="info"
            >
              {{ enums('Advertiser', 'value', item, 'text') }}
            </b-badge>
          </template>

          <template #cell(Screen)="data">
            {{ enums('Screen', 'value', data.value, 'text') }}
          </template>

          <template #cell(Type)="data">
            {{ enums('BannerType', 'value', data.value, 'text') }}
          </template>

          <template #cell(Sorting)="data">
            {{ enums('Sorting', 'value', data.value, 'text') }}
          </template>

          <template #cell(IsActive)="data">
            <b-badge
              :variant="enums('IsActive', 'value', data.value, 'badge')"
            >
              {{ enums('IsActive', 'value', data.value, 'text') }}
            </b-badge>
          </template>

          <template #cell(Click)="data">
            {{ data.value | price }}
          </template>

          <template #cell(Visit)="data">
            {{ data.value | price }}
          </template>

          <template #cell(actions)="data">

            <div
              class="text-nowrap"
            >
              <b-link :to="{ name: 'updatebannerposition', params: { id: data.item.Id }}">
                <feather-icon
                  :id="`invoice-row-${data.item.Id}-send-icon`"
                  icon="EditIcon"
                  size="16"
                />
              </b-link>

              <feather-icon

                icon="TrashIcon"
                size="16"
                class="ml-1 cursor-pointer"
                @click="remove(data.item.Id)"
              />
            </div>
          </template>

          <template #table-busy>
            <div
              class="text-center my-2"
            >
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

          <template #table-busy>
            <div
              class="text-center my-2"
            >
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

        </b-table>

        <z-pagination
          :page="filterOptions.Page"
          :total-rows="totalRows"
          :loading="loading"
          @change="update"
        />

      </b-col>

    </b-row>
  </b-card>
</template>

<script>

export default {
  name: 'BannerPosition',
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      filterOptions: {
        Title: null,
        Screen: null,
        Advertiser: null,
        Page: 1,
        FromDate: this.$moment().startOf('jMonth').format('YYYY/MM/DD'),
        ToDate: this.$moment().endOf('jMonth').format('YYYY/MM/DD')
      },
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'Title',
          label: 'عنوان',
        },
        {
          key: 'Screen',
          label: 'صفحه',
        },
        {
          key: 'Position',
          label: 'جایگاه',
        },
        {
          key: 'Advertiser',
          label: 'آگهی دهنده',
        },
        {
          key: 'Sorting',
          label: 'مرتب سازی',
        },
        {
          key: 'Type',
          label: 'نوع',
        },
        {
          key: 'Click',
          label: 'کلیک',
        },
        {
          key: 'Visit',
          label: 'بازدید',
        },
        {
          key: 'IsActive',
          label: 'وضعیت',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
    }
  },
  computed: {
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(
        this.$api.bannerposition.getlist, this.filterOptions,
      )
        .then(res => {
          this.totalRows = res.totalRow
          this.items = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    remove(id) {
      this.removeRow(this.$api.bannerposition.remove, 'Id', id)
    },
  },
}
</script>
